import { render } from "./tips.vue?vue&type=template&id=6bbbad1a&scoped=true"
const script = {}

import "./tips.vue?vue&type=style&index=0&id=6bbbad1a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbbad1a"]])

export default __exports__